export const getStatus = (accessDate: Date, expiryDate: Date, role?: string) => {
  console.log("role in getStatus:", role);
  if (role === 'admin' || role === 'system-admin') return 'na';

  return new Date(accessDate) < new Date() && new Date(expiryDate) > new Date() ? 'active' : 'inactive';
}